import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { getUsersMock } from './index';
import { WalletUsersApiService } from '../api/wallet-users-api.service';
import { GetUserIdsRes, GetUsersRes } from '../models';

@Injectable()
export class WalletUsersMockApi extends WalletUsersApiService {
  override getUsers(): Observable<GetUsersRes> {
    const users = getUsersMock();

    return of({ users }).pipe(delay(500));
  }

  override getUserIds(): Observable<GetUserIdsRes> {
    return of({ sharedUserIds: [2, 4] }).pipe(delay(500));
  }

  override addUsers(): Observable<void> {
    return of(null).pipe(delay(500));
  }

  override removeUsers(): Observable<void> {
    return of(null).pipe(delay(500));
  }
}
